import React, { useMemo } from 'react';
import { Chip } from '@mui/material';

import './FilterSection.scss';

function FilterTips({ appliedFilters, onRemove }) {
  const chipsData = useMemo(() => {
    return appliedFilters.map(({ id, subheader }) => ({
      id,
      label: subheader,
    }));
  }, [appliedFilters]);

  return (
    <div className='filter-section_tips'>
      {chipsData.map(({ id, label }) => (
        <Chip
          key={id}
          label={label}
          variant='outlined'
          onDelete={() => onRemove(id)}
          size='small'
          sx={{
            height: 'auto',
            '& .MuiChip-label': {
              display: 'block',
              whiteSpace: 'normal',
              color: 'var(--text-default)',
            },
            '& .MuiChip-deleteIcon': {
              color: 'var(--text-default)',
              transition: 'color 0.2s ease',

              '&:hover': {
                color: 'var(--text-stressed)',
              },
            },
          }}
        />
      ))}
    </div>
  );
}

export default FilterTips;
